<template>
  <!--底部栏-->
  <div>
    <section class="footer-wrap hidden">
      <article class="footer">
        <div class="footer-main">
          <div class="main-item">
            <div class="main-item-header">关于平台</div>
            <ul class="main-item-ul">
              <li>网站简介</li>
              <li>发展历程</li>
              <li>荣誉展示</li>
            </ul>
          </div>
          <div class="main-item">
            <div class="main-item-header">业务范畴</div>
            <ul class="main-item-ul">
              <li>货源信息</li>
              <li>车源信息</li>
              <li>仓储信息</li>
            </ul>
          </div>
          <div class="main-item">
            <div class="main-item-header">新闻中心</div>
            <ul class="main-item-ul">
              <li>通知公告</li>
              <li>行业资讯</li>
            </ul>
          </div>
          <div class="main-contact">
            <div class="main-contact-header">联系我们</div>
            <ul class="main-contact-ul">
              <li>地址：<span>{{ bottomData.companyAddress }}</span></li>
              <li>全国客户热线：<span>{{ bottomData.tel }}</span></li>
              <li>企业邮箱：<span>{{ bottomData.email }}</span></li>
            </ul>
          </div>
          <div class="main-app">
            <div class="main-app-header">APP下载</div>
            <ul class="main-app-ul">
              <li>
                <img src="../../assets/img/bf312f53cf635ae480f0e07fcecd860.png" alt="">
                <p>
                  货源端(安卓)
                </p>
              </li>
              <li>
                <img src="../../assets/img/48f99cd5789369e59b5d0209c5f7394.png" alt="">
                <p>
                  运力端(安卓)
                </p>
              </li>
            </ul>
          </div>
          <div class="main-app">
            <div class="main-app-header">》</div>
            <ul class="main-app-ul">
              <li>
                <img src="../../assets/img/11358b344ca02af8adaed4ae80265d1.png" alt="">
                <p>
                  仓储端(安卓)
                </p>
              </li>
            </ul>
          </div>
          <!--
          <div class="main-app">
            <div class="main-app-header">APP下载</div>
            <ul class="main-app-ul">
              <li>
                <img :src="bottomData.telAndroidImgUrl | getImg" alt="">
                <p>Android版本</p>
              </li>
              <li>
                <img :src="bottomData.telIosImgUrl | getImg" alt="">
                <p>
                  IOS版本
                </p>
              </li>
            </ul>
          </div>
          <div class="main-wechat">
            <div class="main-wechat-header">微信公众号</div>
            <div class="main-wechat-box">
              <img :src="bottomData.wecatImgUrl | getImg" alt="">
            </div>
          </div>
          -->
        </div>
        <div class="copyright">
          <p class="copyright-txt">©2020 山东新兴集团有限公司  版权所有</p>
          <p class="copyright-gateway">
            <img src="../../assets/img/gateway.png" alt="">
            鲁ICP备2021001781号
          </p>
        </div>
      </article>
    </section>
  </div>
</template>

<script type="text/ecmascript-6">
import * as get from '@/api/footer/index.js'

export default {
  name: 'Footer',
  data() {
    return {
      list: [],
      bottomData: []
    }
  },
  created() {
    get.getData().then(res => {
      this.bottomData = res.result
    }).catch(error => {
      console.log(error)
    })
  },
  mounted() {},
  methods: {

  }
}
</script>

<style scoped lang='scss'>
  .footer-wrap{
    width: 100%;
    height: 400px;
    background: #333333;
    .footer{
      width: 1200px;
      margin: 0 auto;
      padding-top: 50px;
      .footer-main{
        display: flex;
        height: 200px;
        border-bottom: 2px solid #474747;
        .main-item{
          width: 170px;
          height: 200px;
          .main-item-header{
            color: #ECECEC;
            font-size: 20px;
            padding-bottom: 30px;
          }
          .main-item-ul{
            li{
              color: #ECECEC;
              font-size: 16px;
              margin-bottom: 20px;
              cursor: pointer;
            }
          }
        }
        .main-contact{
          width: 330px;
          height: 200px;
          .main-contact-header{
            color: #ECECEC;
            font-size: 20px;
            padding-bottom: 30px;
          }
          .main-contact-ul{
            width: 220px;
            li{
              color: #ECECEC;
              font-size: 16px;
              margin-bottom: 20px;
              &:nth-child(1){
                span{
                  line-height: 24px;
                }
              }
            }
          }
        }
        .main-app{
          width: 240px;
          height: 200px;
          .main-app-header{
            color: #ECECEC;
            font-size: 20px;
            padding-bottom: 30px;
            text-align: center;
          }
          .main-app-ul{
            width: 100%;
            li{
              float: left;
              width: 50%;
              img{
                width: 105px;
                height: 105px;
                margin-left: 7px;
              }
              p{
                color: #FFFFFF;
                font-size: 16px;
                text-align: center;
                padding-top: 10px;
              }
            }
          }
        }
        .main-wechat{
          width: 120px;
          height: 200px;
          .main-wechat-header{
            color: #ECECEC;
            font-size: 20px;
            padding-bottom: 30px;
            text-align: center;
          }
          .main-wechat-box{
            img{
              width: 105px;
              height: 105px;
              margin-left: 7px;
            }
          }
        }
      }
      .copyright{
        margin-top: 40px;
        .copyright-txt{
          text-align: center;
          color: #858585;
          padding-bottom: 10px;
        }
        .copyright-gateway{
          text-align: center;
          color: #858585;
          img{
            vertical-align: middle;

          }
        }
      }
    }
  }
  @media print {
  .hidden{
      display: none;
  }
}
</style>
